import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Pagination,
  InputGroup,
  Badge,
} from "react-bootstrap";

export default function FundManagementsendUser() {

  const transferData = [
    { id: 1, userId: "USR1001", name: "Arun Kumar", amount: "₹5,000", date: "02 Jun 2026" },
    { id: 2, userId: "USR1002", name: "Rahul", amount: "₹8,500", date: "01 Jun 2026" },
    { id: 3, userId: "USR1003", name: "Vijay", amount: "₹3,000", date: "31 May 2026" },
    { id: 4, userId: "USR1004", name: "Karthik", amount: "₹12,000", date: "30 May 2026" },
    { id: 5, userId: "USR1005", name: "Praveen", amount: "₹4,500", date: "29 May 2026" },
    { id: 6, userId: "USR1006", name: "Suresh", amount: "₹6,000", date: "28 May 2026" },
    { id: 7, userId: "USR1007", name: "Ajith", amount: "₹2,500", date: "27 May 2026" },
    { id: 8, userId: "USR1008", name: "Kiran", amount: "₹9,000", date: "26 May 2026" },
    { id: 9, userId: "USR1009", name: "Raghu", amount: "₹7,200", date: "25 May 2026" },
    { id: 10, userId: "USR1010", name: "Manoj", amount: "₹15,000", date: "24 May 2026" },
  ];

  const [page, setPage] = useState(1);

  const perPage = 5;
  const totalPages = Math.ceil(transferData.length / perPage);

  const currentData = transferData.slice(
    (page - 1) * perPage,
    page * perPage
  );

  const buildPages = () => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="fms-page">

      <Container fluid>



        <Row className="g-4 mb-4">

          <Col xl={12}>

            <Card className="fms-form-card">


              <div className="fms-card-inner">


                <div className="fms-left-panel">

                  <div className="fms-left-icon">
                    <i className="bi bi-send-fill"></i>
                  </div>

                  <h2 className="fms-left-title">Send Fund<br />To Member</h2>

                  <p className="fms-left-sub">
                    Transfer funds securely to any registered user in the network.
                  </p>

                  <div className="fms-stat-row">
                    <div className="fms-stat-item">
                      <span className="fms-stat-num">{transferData.length}</span>
                      <span className="fms-stat-label">Total Transfers</span>
                    </div>
                    <div className="fms-stat-divider" />
                    <div className="fms-stat-item">
                      <span className="fms-stat-num">₹72.7K</span>
                      <span className="fms-stat-label">Total Amount</span>
                    </div>
                  </div>

                </div>


                <div className="fms-right-panel">

                  <div className="fms-form-label-top">
                    <span className="fms-step-tag">NEW TRANSFER</span>
                    <h4 className="fms-form-heading">Enter Transfer Details</h4>
                  </div>

                  <Form>

                    <Row className="g-4">

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            <i className="bi bi-person-badge me-2"></i>User ID
                          </Form.Label>
                          <Form.Control
                            className="fms-input"
                            placeholder="e.g. USR1001"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            <i className="bi bi-person me-2"></i>Member Name
                          </Form.Label>
                          <Form.Control
                            className="fms-input"
                            placeholder="Full name"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>
                            <i className="bi bi-currency-rupee me-2"></i>Amount
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text className="fms-input-prefix">₹</InputGroup.Text>
                            <Form.Control
                              className="fms-input fms-input-amount"
                              placeholder="0.00"
                            />
                          </InputGroup>
                        </Form.Group>
                      </Col>

                    </Row>

                    <div className="fms-form-footer">
                      <Button className="fms-send-btn">
                        <i className="bi bi-send-fill me-2"></i>
                        Send Fund
                      </Button>
                      <Button className="fms-reset-btn" variant="link">
                        Clear Form
                      </Button>
                    </div>

                  </Form>

                </div>

              </div>

            </Card>

          </Col>

        </Row>

        <Row className="mb-3">

          <Col lg={12}>

            <div className="fms-table-header">

              <div className="fms-header-top">

                <div>

                  <h3>Fund Transfer Details</h3>

                  <p>Recent fund transfer records</p>

                </div>

                <Badge className="bg-info text-dark fw-bold px-3 py-2 rounded-3">
                  {transferData.length} Records
                </Badge>

              </div>

              <div className="fms-header-search">

                <InputGroup className="fms-search">

                  <InputGroup.Text>
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>

                  <Form.Control
                    placeholder="Search member..."
                  />

                </InputGroup>

              </div>

            </div>

          </Col>

        </Row>



        <Card className="ud-table-card">
          <div className="ud-scroll-wrap">

            <Table hover borderless className="ud-table align-middle mb-0">

              <thead>
                <tr>
                  <th>SR NO</th>
                  <th>USER ID</th>
                  <th>NAME</th>
                  <th>AMOUNT</th>
                  <th>DATE</th>
                </tr>
              </thead>

              <tbody>
                {currentData.map((user) => (
                  <tr key={user.id}>

                    <td>{user.id}</td>

                    <td>
                      <span className="fms-userid">{user.userId}</span>
                    </td>

                    <td>
                      <div className="ud-user-cell">
                        {/* <span className="ud-avatar">{getInitials(user.name)}</span> */}
                        <span className="ud-user-name">{user.name}</span>
                      </div>
                    </td>

                    <td>
                      <Badge className="bg-info text-dark fw-bold px-3 py-2 rounded-3">{user.amount}</Badge>
                    </td>

                    <td>{user.date}</td>

                  </tr>
                ))}
              </tbody>

            </Table>

          </div>

        </Card>



        <div className="ud-pagination-wrap">

          <Pagination className="ud-pagination">

            <Pagination.Prev
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />

            {buildPages().map((p) => (
              <Pagination.Item
                key={p}
                active={page === p}
                onClick={() => setPage(p)}
              >
                {p}
              </Pagination.Item>
            ))}

            <Pagination.Next
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            />

          </Pagination>

        </div>

      </Container>

    </div>
  );
}